function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 2.5,
  y: 2.5,
  width: 29,
  height: 29,
  rx: 14.5,
  fill: "#00D494"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.3534 12.7717C21.0114 12.5223 20.5329 12.5986 20.2845 12.9421L15.7106 19.3335L13.7196 16.8374C13.5517 16.6032 13.2673 16.4832 12.9833 16.5266C12.6992 16.5701 12.4633 16.7698 12.3725 17.0437C12.2817 17.3175 12.3512 17.6194 12.5525 17.8254L15.1596 21.1005C15.4313 21.4255 15.9137 21.468 16.2374 21.1953V21.1953C16.3004 21.1418 16.3546 21.0787 16.3981 21.0082L21.5192 13.8455C21.7683 13.5029 21.6941 13.0224 21.3534 12.7717Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.3534 12.7717C21.0114 12.5223 20.5329 12.5986 20.2845 12.9421L15.7106 19.3335L13.7196 16.8374C13.5517 16.6032 13.2673 16.4832 12.9833 16.5266C12.6992 16.5701 12.4633 16.7698 12.3725 17.0437C12.2817 17.3175 12.3512 17.6194 12.5525 17.8254L15.1596 21.1005C15.4313 21.4255 15.9137 21.468 16.2374 21.1953V21.1953C16.3004 21.1418 16.3546 21.0787 16.3981 21.0082L21.5192 13.8455C21.7683 13.5029 21.6941 13.0224 21.3534 12.7717Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_1855:6954)"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 2.5,
  y: 2.5,
  width: 29,
  height: 29,
  rx: 14.5,
  stroke: "#CCF6E9",
  strokeWidth: 5
});

function SvgIconStatusActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1855:6954",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 10,
    height: 10
  }, _ref4), _ref5, _ref6);
}

var ForwardRef = React.forwardRef(SvgIconStatusActive);
export default __webpack_public_path__ + "static/media/icon-status-active.c5531117.svg";
export { ForwardRef as ReactComponent };